export const BreakPoints = {
  mobile: "560px",
  tablet: "770px",
  desktopLarge: "1000px",
};
